<template>
  <figure v-if="data.video_mp4" :class="data.classNames" :style="'background-color: '+data.styles_background_colour+';'">
    <slot />
    <video :src="windowWidth < 801 && data.video_mobile_mp4 ? data.video_mobile_mp4[0].url : data.video_mp4[0].url" :data-original="data.video_mp4[0].url" :data-mobile="data.video_mobile_mp4 && data.video_mobile_mp4[0].url" playsinline="" autoplay="" muted="" loop="" class="">
      <source v-if="data.video_webm" :src="data.video_webm[0].url" type="video/webm" />
      <source :src="data.video_mp4[0].url" type="video/mp4" />
    </video>
  </figure>
</template>

<script>
import { firestore } from '../main'

export default {
  name: 'VideoBlock',
  props: ['data'],
  data () {
    return {
      windowWidth: window.innerWidth
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/VideoBlock.vue